import React from 'react'
import Card from '../Card/Card'

function CardSelector(props) {
    return (
        props.list.map((card, index) =>
            <div key={index} className={"col-lg-6 mx-auto center-parent " +  (card.disabled === true ? "card-disabled" : "card-radio")}>
                <label className={'center-child' + (card.disabled === true ? " disabled" : "")} style={{ width: "calc(100% - 20px)" }}>
                    <input type="radio" name={props.groupName} className="card-input-element" value={card.id} onClick={props.onCardSelected} onChange={() => { }}
                        checked={card.checked} />
                    <Card title={card.title} subTitle={card.subTitle} description={card.description}
                        icon={card.icon}></Card>
                </label>
            </div>
        )
    )
}

export default CardSelector